import { useTranslation } from '@/i18n';
import { Tabs } from '@payaca/ambrosia';

import { FC } from 'react';
import { Helmet } from 'react-helmet';

import AuthenticatedPageWrapper from '@/ui/layouts/authenticatedPageWrapper/AuthenticatedPageWrapper';
import AutomationsTab from './components/AutomationsTab';

const AutomationsRebuildPage: FC = () => {
  const translate = useTranslation();

  return (
    <>
      <Helmet title={translate('pages.automations.title')} />
      <AuthenticatedPageWrapper>
        <div className="p-4 pb-6">
          <Tabs>
            <Tabs.Panel
              label={translate('automations.pageTabs.automations')}
              render={() => <AutomationsTab />}
            />
            <Tabs.Panel
              label={translate('automations.pageTabs.activity')}
              render={() => <></>}
            />
          </Tabs>
        </div>
      </AuthenticatedPageWrapper>
    </>
  );
};

export default AutomationsRebuildPage;
